import React from "react";

import Button from "components/ui/Button";

// Full-screen message: optional illustration, title, text and one action.
// Used for loading, errors, 401/404 and "you joined" screens.
export default function StatusScreen({ image, title, children, action }) {
  return (
    <section className="yc-status">
      {image && <img src={`${process.env.PUBLIC_URL}/assets/images/${image}`} alt="" />}
      {title && <h1>{title}</h1>}
      {children && <div className="yc-status-text">{children}</div>}
      {action && (
        <Button className="yc-status-action" to={action.to} href={action.href}>
          {action.label}
        </Button>
      )}
    </section>
  );
}

export function Loading() {
  return <StatusScreen title="Doing science..." />;
}
